import _regeneratorRuntime from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { cloneNode } from './clone-node';
import { embedImages } from './embed-images';
import { applyStyle } from './apply-style';
import { embedWebFonts, getWebFontCSS } from './embed-webfonts';
import { getImageSize, getPixelRatio, createImage, canvasToBlob, nodeToDataURL, checkCanvasDimensions } from './util';
export function toSvg(_x) {
  return _toSvg.apply(this, arguments);
}

function _toSvg() {
  _toSvg = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(node) {
    var options,
        _getImageSize,
        width,
        height,
        clonedNode,
        datauri,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            _getImageSize = getImageSize(node, options), width = _getImageSize.width, height = _getImageSize.height;
            _context.next = 4;
            return cloneNode(node, options, true);

          case 4:
            clonedNode = _context.sent;
            _context.next = 7;
            return embedWebFonts(clonedNode, options);

          case 7:
            _context.next = 9;
            return embedImages(clonedNode, options);

          case 9:
            applyStyle(clonedNode, options);
            _context.next = 12;
            return nodeToDataURL(clonedNode, width, height);

          case 12:
            datauri = _context.sent;
            return _context.abrupt("return", datauri);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _toSvg.apply(this, arguments);
}

export function toCanvas(_x2) {
  return _toCanvas.apply(this, arguments);
}

function _toCanvas() {
  _toCanvas = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(node) {
    var options,
        _getImageSize2,
        width,
        height,
        svg,
        img,
        canvas,
        context,
        ratio,
        canvasWidth,
        canvasHeight,
        _args2 = arguments;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
            _getImageSize2 = getImageSize(node, options), width = _getImageSize2.width, height = _getImageSize2.height;
            _context2.next = 4;
            return toSvg(node, options);

          case 4:
            svg = _context2.sent;
            _context2.next = 7;
            return createImage(svg);

          case 7:
            img = _context2.sent;
            canvas = document.createElement('canvas');
            context = canvas.getContext('2d');
            ratio = options.pixelRatio || getPixelRatio();
            canvasWidth = options.canvasWidth || width;
            canvasHeight = options.canvasHeight || height;
            canvas.width = canvasWidth * ratio;
            canvas.height = canvasHeight * ratio;

            if (!options.skipAutoScale) {
              checkCanvasDimensions(canvas);
            }

            canvas.style.width = "".concat(canvasWidth);
            canvas.style.height = "".concat(canvasHeight);

            if (options.backgroundColor) {
              context.fillStyle = options.backgroundColor;
              context.fillRect(0, 0, canvas.width, canvas.height);
            }

            context.drawImage(img, 0, 0, canvas.width, canvas.height);
            return _context2.abrupt("return", canvas);

          case 21:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _toCanvas.apply(this, arguments);
}

export function toPixelData(_x3) {
  return _toPixelData.apply(this, arguments);
}

function _toPixelData() {
  _toPixelData = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(node) {
    var options,
        _getImageSize3,
        width,
        height,
        canvas,
        ctx,
        _args3 = arguments;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            options = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
            _getImageSize3 = getImageSize(node, options), width = _getImageSize3.width, height = _getImageSize3.height;
            _context3.next = 4;
            return toCanvas(node, options);

          case 4:
            canvas = _context3.sent;
            ctx = canvas.getContext('2d');
            return _context3.abrupt("return", ctx.getImageData(0, 0, width, height).data);

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _toPixelData.apply(this, arguments);
}

export function toPng(_x4) {
  return _toPng.apply(this, arguments);
}

function _toPng() {
  _toPng = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(node) {
    var options,
        canvas,
        _args4 = arguments;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            options = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
            _context4.next = 3;
            return toCanvas(node, options);

          case 3:
            canvas = _context4.sent;
            return _context4.abrupt("return", canvas.toDataURL());

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _toPng.apply(this, arguments);
}

export function toJpeg(_x5) {
  return _toJpeg.apply(this, arguments);
}

function _toJpeg() {
  _toJpeg = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5(node) {
    var options,
        canvas,
        _args5 = arguments;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            options = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
            _context5.next = 3;
            return toCanvas(node, options);

          case 3:
            canvas = _context5.sent;
            return _context5.abrupt("return", canvas.toDataURL('image/jpeg', options.quality || 1));

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _toJpeg.apply(this, arguments);
}

export function toBlob(_x6) {
  return _toBlob.apply(this, arguments);
}

function _toBlob() {
  _toBlob = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee6(node) {
    var options,
        canvas,
        blob,
        _args6 = arguments;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            options = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : {};
            _context6.next = 3;
            return toCanvas(node, options);

          case 3:
            canvas = _context6.sent;
            _context6.next = 6;
            return canvasToBlob(canvas);

          case 6:
            blob = _context6.sent;
            return _context6.abrupt("return", blob);

          case 8:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _toBlob.apply(this, arguments);
}

export function getFontEmbedCSS(_x7) {
  return _getFontEmbedCSS.apply(this, arguments);
}

function _getFontEmbedCSS() {
  _getFontEmbedCSS = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee7(node) {
    var options,
        _args7 = arguments;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            options = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : {};
            return _context7.abrupt("return", getWebFontCSS(node, options));

          case 2:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _getFontEmbedCSS.apply(this, arguments);
}